export default __webpack_public_path__ + "static/media/por-bankStatementPOR.43bcbbb4.png";